import {CreateRoot} from "../react";
import LoginWidget from "../react/components/login/widget/login-widget";
import CorporateLoginWidget from "../react/components/login/widget/corporate-login-widget";
import React from "react";

CreateRoot('login-widget', <LoginWidget />);
CreateRoot('login-widget-corp', <CorporateLoginWidget />);

